<template>
  <div>
    <SubHeader title="Company Details" />
    <CompanyRequestRegNumberChange ref="companyRequestRegNumberChange" :companyId="parseInt(companyId)" />
    <b-form
      @submit="onSubmit"
      @reset="onReset"
      class="container"
      v-if="localCompany"
    >
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="companyName">Registered Name</label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="companyName"
            v-model="localCompany.companyName"
          :disabled="onTheMarket"
           ></b-form-input>
        </b-col>
        <b-col md="4">
          <!-- <b-button
            class="todo"
            variant="primary"
            :disabled="localCompany.contactPreference == 1"
          >
            <font-awesome-icon icon="check-circle" /> Set as Main Company
          </b-button> -->
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="tradingAsName">Trading As</label>
        </b-col>
        <b-col md="7">
          <b-form-input
            id="tradingAsName"
            v-model="localCompany.tradingAsName"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="importantBusinessDetails"
            >Important Business Details</label
          >
        </b-col>
        <b-col md="7">
          <b-form-textarea
            id="importantBusinessDetails"
            v-model="localCompany.importantBusinessDetails"
                           :disabled="onTheMarket"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-1" v-if="statuses">
        <b-col md="3" class="label" v-bind:class="{red: statuses.isOne80SuppressedStatus == true || statuses.isOne80HoldStatus == true}">One80 Status</b-col>
        <b-col md="7" v-bind:class="{red: statuses.isOne80SuppressedStatus == true || statuses.isOne80HoldStatus == true}">
          {{statuses.one80Status}}
        </b-col>
      </b-row>
      <b-row class="my-1" v-if="statuses">
        <b-col md="3" class="label" v-bind:class="{red: statuses.isGlobeSuppressedStatus == true || statuses.isGlobeHoldStatus == true}">Globe Status</b-col>
        <b-col md="7" v-bind:class="{red: statuses.isGlobeSuppressedStatus == true || statuses.isGlobeHoldStatus == true}">
          {{statuses.globeStatus}}
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="guocompanyName">GUO Name</label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="guocompanyName"
            v-model="localCompany.guocompanyName"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="registeredNumber">Company Number</label>
        </b-col>
        <b-col md="5">
          <b-form-input id="registeredNumber"
                        v-model="localCompany.registeredNumber"
                        disabled></b-form-input>
        </b-col>
        <b-col md="4">
          <b-button variant="danger"
                    :disabled="onTheMarket"
                    @click="requestRegNumberChangeModal()">
            <font-awesome-icon icon="edit" /> Request Change
          </b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressLine1">Trading Address Line</label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressLine1"
            v-model="localCompany.addressLine1"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
        <b-col md="4">
          <b-button
            variant="primary"
            v-on:click="this.copyTradingFromMainContact"
            :disabled="this.isMainContactAddBlank() || onTheMarket"
          >
            <font-awesome-icon icon="copy" /> Copy From Main Contact
          </b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressLine2"></label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressLine2"
            v-model="localCompany.addressLine2"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressLine3"></label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressLine3"
            v-model="localCompany.addressLine3"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressLine4"></label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressLine4"
            v-model="localCompany.addressLine4"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressLine5"></label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressLine5"
            v-model="localCompany.addressLine5"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressTown">Town</label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressTown"
            v-model="localCompany.addressTown"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="addressCounty">County</label>
        </b-col>
        <b-col md="5">
          <b-form-input
            id="addressCounty"
            v-model="localCompany.addressCounty"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="postcode">Postcode</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            id="postcode"
            v-model="localCompany.postcode"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="regionId">Region</label>
        </b-col>
        <b-col md="3">
          <b-form-select
            id="companyTierId"
            :options="lookups.regions"
            v-model="localCompany.regionId"
            value-field="id"
            text-field="name"
            v-if="lookups"
                         :disabled="onTheMarket"
          ></b-form-select>
        </b-col>
      </b-row>

      <br />
      <b-row class="my-1">
        <b-col md="12">
          <b-button v-b-toggle.trading-collapse variant="outline-secondary"
            ><font-awesome-icon icon="chevron-down" /> Show Registered Address
          </b-button>
        </b-col>
      </b-row>
      <b-collapse id="trading-collapse" class="mt-2">
        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressLine1">Registered Address</label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressLine1"
              v-model="localCompany.correspondenceAddressLine1"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <b-button
              variant="primary"
              v-on:click="this.copyRegisteredFromTrade"
              :disabled="this.isTradingAddBlank() || onTheMarket"
            >
              <font-awesome-icon icon="copy" /> Copy From Trading Address
            </b-button>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressLine2"></label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressLine2"
              v-model="localCompany.correspondenceAddressLine2"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
          <b-col md="4">
            <b-button
              variant="primary"
              v-on:click="this.copyRegisteredFromMainContact"
              :disabled="this.isMainContactAddBlank() || onTheMarket"
            >
              <font-awesome-icon icon="copy" /> Copy From Main Contact
            </b-button>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressLine3"></label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressLine3"
              v-model="localCompany.correspondenceAddressLine3"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressLine4"></label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressLine4"
              v-model="localCompany.correspondenceAddressLine4"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressLine5"></label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressLine5"
              v-model="localCompany.correspondenceAddressLine5"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressTown">Town</label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressTown"
              v-model="localCompany.correspondenceAddressTown"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondenceAddressCounty">County</label>
          </b-col>
          <b-col md="5">
            <b-form-input
              id="correspondenceAddressCounty"
              v-model="localCompany.correspondenceAddressCounty"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="correspondencePostcode">Postcode</label>
          </b-col>
          <b-col md="2">
            <b-form-input
              id="correspondencePostcode"
              v-model="localCompany.correspondencePostcode"
                          :disabled="onTheMarket"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-collapse>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="website">Website</label>
        </b-col>
        <b-col md="5">
          <b-input-group class="mt-3">
            <b-form-input
              id="website"
              v-model="localCompany.websiteUrl"
                          :disabled="onTheMarket"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click="openLink"
                :disabled="!localCompany.websiteUrl"
                variant="outline-secondary"
                ><font-awesome-icon icon="external-link" /> Link</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="companyEstablishedYear">Established Since</label>
        </b-col>
        <b-col md="2">
          <b-form-input
            id="companyEstablishedYear"
            v-model="localCompany.companyEstablishedYear"
                        :disabled="onTheMarket"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="input-none">Group Companies</label>
        </b-col>
        <b-col md="9">
          <b-table
            hover
            :items="localCompany.companyGroupCompanies"
            :fields="groupFields"
          >
            <template v-slot:cell(company)="data">
              <router-link :to="'/company/' + data.item.companyId">{{
                data.item.companyName
              }}</router-link>
            </template>
            <template v-slot:cell(main)="data">
              <span v-if="data.item.contactPreference == 1"
                ><font-awesome-icon icon="check" /> Main Company
              </span>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="companyTierId">Tier</label>
        </b-col>
        <b-col md="3">
          <b-form-select
            id="companyTierId"
            :options="lookups.companyTiers"
            v-model="localCompany.companyTierId"
            value-field="id"
            text-field="randdName"
            v-if="lookups"
                         :disabled="onTheMarket"
          ></b-form-select>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
          <label for="input-none"></label>
        </b-col>
        <b-col md="9">
          <b-button type="submit" variant="success" class="margin-right" :disabled="onTheMarket">
            <font-awesome-icon icon="save" /> Save
          </b-button>
          <b-button type="reset" variant="danger">
            <font-awesome-icon icon="times" /> Cancel Changes
          </b-button>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="9">
          <Feedback ref="saveFeedback"/>
        </b-col>
      </b-row>

    </b-form>

    <SubHeader title="Linked Companies" />
    <div v-if="linkedCompanies">
      <b-row class="my-1">
        <b-col md="12">
          <b-table :items="linkedCompanies" :fields="linkFields">
            <template v-slot:cell(name)="data">
              {{ data.item.name }}
            </template>
            <template v-slot:cell(address)="data">
              {{ data.item.address }}
            </template>
            <template v-slot:cell(linkedDate)="data">
              {{ getDate(data.item.linkedDate) }}
            </template>

            <template v-slot:cell(nav)="data">
              <b-button
                size="sm"
                :to="'/company/' + data.item.companyId"
                variant="warning"
                >Details</b-button
              >
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col md="12" v-if="linkedCompanies">
          <b-button variant="primary" @click="addLink" :disabled="onTheMarket">Add Link</b-button>
        </b-col>
      </b-row>
    </div>
    <CompanyAddLinkModal ref="companyAddLinkModal" :lookups="lookups" :companyId="companyId"/>
  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import { format } from "date-fns";
import CompanyAddLinkModal from "@/components/company/overview/CompanyAddLinkModal.vue";
import Feedback from '@/components/shared/Feedback.vue';
  import CompanyService from '@/services/Company.service';
  import CompanyRequestRegNumberChange from "@/components/company/overview/CompanyRequestRegNumberChangeModal.vue";

export default {
  name: "CompanyOverview",
  components: { SubHeader, CompanyAddLinkModal, Feedback, CompanyRequestRegNumberChange },
  props: {
    companyId: String,
    company: Object,
    mainContact: Object,
    linkedCompanies: Array,
    lookups: Object,
    statuses: Object
  },
  /*created() {
    this.originalCompany = this.company;
  },*/
  mounted() {
    if (this.company && this.localCompany == null) {
      this.localCompany = { ...this.company };
      console.log(this.company);
    }
  },
  watch: {
    company: function () {
      this.localCompany = { ...this.company };
      this.onTheMarket = this.company.companyLocked;
    },
  },
  data() {
    return {
      localCompany: null,
      onTheMarket: false,
      groupFields: [
        { key: "company", label: "Company Name" },
        { key: "companyHierarchy.name", label: "Company Level" },
        { key: "companyTier.name", label: "Tier" },
        { key: "main", label: "" },
      ],
      linkFields: [
        { key: "name", label: "Company" },
        { key: "address", label: "Address " },
        { key: "linkedDate", label: "	Linked On" },
        { key: "nav", label: "" },
      ],
      /*tiers: [
        { value: null, text: "Not Selected" },
        { value: 0, text: "Unknown" },
        { value: 10, text: "Tier 1" },
        { value: 20, text: "Tier 2" },
        { value: 30, text: "Tier 3" },
        { value: 100, text: "Small Commercial" },
        { value: 105, text: "Smaller Commercial" },
        { value: 110, text: "High Profit" },
        { value: 120, text: "Creditsafe" },
        { value: 130, text: "Buyer" },
      ],*/
      // originalCompany: null
    };
  },
  computed: {
    getUrl() {
      if (this.localCompany.websiteUrl.startsWith("http")) {
        return this.localCompany.websiteUrl;
      } else if (this.localCompany.websiteUrl == "") {
        return "";
      } else {
        return "http://" + this.localCompany.websiteUrl
      }
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();

      var save = {
        Id: this.localCompany.id,
        CompanyName: this.localCompany.companyName,
        TradingAsName: this.localCompany.tradingAsName,
        ImportantBusinessDetails: this.localCompany.importantBusinessDetails,
        GuocompanyName: this.localCompany.guocompanyName,
        RegisteredNumber: this.localCompany.registeredNumber,
        AddressLine1: this.localCompany.addressLine1,
        AddressLine2: this.localCompany.addressLine2,
        AddressLine3: this.localCompany.addressLine3,
        AddressLine4: this.localCompany.addressLine4,
        AddressLine5: this.localCompany.addressLine5,
        AddressTown: this.localCompany.addressTown,
        AddressCounty: this.localCompany.addressCounty,
        Postcode: this.localCompany.postcode,
        CorrespondenceAddressLine1: this.localCompany
          .correspondenceAddressLine1,
        CorrespondenceAddressLine2: this.localCompany
          .correspondenceAddressLine2,
        CorrespondenceAddressLine3: this.localCompany
          .correspondenceAddressLine3,
        CorrespondenceAddressLine4: this.localCompany
          .correspondenceAddressLine4,
        CorrespondenceAddressLine5: this.localCompany
          .correspondenceAddressLine5,
        CorrespondenceAddressTown: this.localCompany.correspondenceAddressTown,
        CorrespondenceAddressCounty: this.localCompany
          .correspondenceAddressCounty,
        CorrespondencePostcode: this.localCompany.correspondencePostcode,
        websiteUrl: this.localCompany.websiteUrl,
        CompanyEstablishedYear: this.localCompany.companyEstablishedYear,
        CompanyTierId: this.localCompany.companyTierId,
        RegionId: this.localCompany.regionId,
      };

      CompanyService.saveOverview(save).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
        this.company = {...this.localCompany };
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.localCompany = { ...this.company };
    },
    isMainContactAddBlank() {
      if (!this.mainContact) return true;

      if (
        this.mainContact.correspondenceAddressLine1 +
          this.mainContact.correspondenceAddressLine2 +
          this.mainContact.correspondenceAddressLine3 +
          this.mainContact.correspondenceAddressLine4 +
          this.mainContact.correspondenceAddressLine5 +
          this.mainContact.correspondenceAddressTown +
          this.mainContact.correspondenceAddressCounty +
          this.mainContact.correspondencePostcode ==
        ""
      )
        return true;
      return false;
    },
    isTradingAddBlank() {
      if (!this.localCompany) return true;

      if (
        this.localCompany.addressLine1 +
          this.localCompany.addressLine2 +
          this.localCompany.addressLine3 +
          this.localCompany.addressLine4 +
          this.localCompany.addressLine5 +
          this.localCompany.addressTown +
          this.localCompany.addressCounty +
          this.localCompany.postcode ==
        ""
      )
        return true;
      return false;
    },
    copyTradingFromMainContact() {
      this.localCompany.addressLine1 = this.mainContact.correspondenceAddressLine1;
      this.localCompany.addressLine2 = this.mainContact.correspondenceAddressLine2;
      this.localCompany.addressLine3 = this.mainContact.correspondenceAddressLine3;
      this.localCompany.addressLine4 = this.mainContact.correspondenceAddressLine4;
      this.localCompany.addressLine5 = this.mainContact.correspondenceAddressLine5;
      this.localCompany.addressTown = this.mainContact.correspondenceAddressTown;
      this.localCompany.addressCounty = this.mainContact.correspondenceAddressCounty;
      this.localCompany.postcode = this.mainContact.correspondencePostcode;
    },
    copyRegisteredFromMainContact() {
      this.localCompany.correspondenceAddressLine1 = this.mainContact.correspondenceAddressLine1;
      this.localCompany.correspondenceAddressLine2 = this.mainContact.correspondenceAddressLine2;
      this.localCompany.correspondenceAddressLine3 = this.mainContact.correspondenceAddressLine3;
      this.localCompany.correspondenceAddressLine4 = this.mainContact.correspondenceAddressLine4;
      this.localCompany.correspondenceAddressLine5 = this.mainContact.correspondenceAddressLine5;
      this.localCompany.correspondenceAddressTown = this.mainContact.correspondenceAddressTown;
      this.localCompany.correspondenceAddressCounty = this.mainContact.correspondenceAddressCounty;
      this.localCompany.correspondencePostcode = this.mainContact.correspondencePostcode;
    },
    copyRegisteredFromTrade() {
      this.localCompany.correspondenceAddressLine1 = this.localCompany.addressLine1;
      this.localCompany.correspondenceAddressLine2 = this.localCompany.addressLine2;
      this.localCompany.correspondenceAddressLine3 = this.localCompany.addressLine3;
      this.localCompany.correspondenceAddressLine4 = this.localCompany.addressLine4;
      this.localCompany.correspondenceAddressLine5 = this.localCompany.addressLine5;
      this.localCompany.correspondenceAddressTown = this.localCompany.addressTown;
      this.localCompany.correspondenceAddressCounty = this.localCompany.addressCounty;
      this.localCompany.correspondencePostcode = this.localCompany.postcode;
    },
    openLink() {
      let url = ""
      if (this.localCompany.websiteUrl.startsWith("http")) {
        url = this.localCompany.websiteUrl;
      } else if (this.localCompany.websiteUrl == "") {
        url = "";
      } else {
        url = "http://" + this.localCompany.websiteUrl
      }

      window.open(url, "_blank");
    },

    getDate(date) {
      if (date == null) return "";
      return format(new Date(date), "dd/MM/yyyy HH:mm");
    },
    addLink() {
      this.$refs.companyAddLinkModal.showModal()
    },
    requestRegNumberChangeModal() {
      //console.log("OpenModal");
      this.$refs.companyRequestRegNumberChange.showModal();
    },
  },
};
</script>

<style scoped>
.input-row {
  margin-bottom: 0.25rem !important;
}
.table {
  font-size: 0.85em;
}
.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>
